@file: UseSerializers(UuidSerializer::class)

package it.neckar.lizergy.model.configuration.quote.builder

import it.neckar.lizergy.lifeCycle.LizergyHasLifeCycle
import it.neckar.lizergy.lifeCycle.LizergyLifeCycleState
import it.neckar.uuid.HasValueClassUuid
import it.neckar.uuid.NativeUuid
import it.neckar.uuid.UuidSerializer
import it.neckar.uuid.ValueClassUuid
import it.neckar.uuid.randomUuid4
import kotlinx.serialization.Serializable
import kotlinx.serialization.UseSerializers
import kotlin.uuid.Uuid

/**
 * "Schwierigkeit der Montage"
 */
@Serializable
data class AssemblyDifficulty(
  override val id: AssemblyDifficultyId,

  val description: String,

  override val lifeCycleState: LizergyLifeCycleState = LizergyLifeCycleState.Active,

  ) : HasValueClassUuid, LizergyHasLifeCycle {

  /**
   * An id for an assembly difficulty
   */
  @Serializable
  data class AssemblyDifficultyId(override val uuid: NativeUuid) : ValueClassUuid {

    override fun toString(): String {
      return uuid.toString()
    }

    fun format(): String {
      return uuid.toString()
    }

    companion object {
      fun random(): AssemblyDifficultyId {
        return AssemblyDifficultyId(randomUuid4())
      }
    }
  }
}
